<template>
  <b-navbar
    type="dark"
    toggleable="xl"
    fixed="top"
    class="header-area header-background"
    id="header"
    :class="{ 'is-sticky': scrolled }"
  >
    <div class="container-fluid container-fluid--cp-150">
      <b-navbar-toggle target="nav_collapse" aria-label="Abrir menú principal"></b-navbar-toggle>

      <b-navbar-brand href="#home" class="navbar-brand" @click.prevent="scroll('#home')">
        <img src="../assets/img/logo/img-logo-header.png" alt="Leonix" />
      </b-navbar-brand>

      <b-collapse class="default-nav justify-content-center" is-nav id="nav_collapse">
        <b-navbar-nav class="navbar-nav main-menu">

          <b-nav-item href="#home" class="nav-link-item" @click.prevent="scroll('#home')">
            <span>Inicio</span>
          </b-nav-item>

          <b-nav-item href="#about" class="nav-link-item" @click.prevent="scroll('#about')">
            <span>¿Quiénes somos?</span>
          </b-nav-item>

          <b-nav-item href="#service" class="nav-link-item" @click.prevent="scroll('#service')">
            <span>Qué hacemos</span>
          </b-nav-item>

          <b-nav-item href="#metodologia" class="nav-link-item" @click.prevent="scroll('#metodologia')">
            <span>Metodología</span>
          </b-nav-item>

          <b-nav-item href="#contact" class="nav-link-item" @click.prevent="scroll('#contact')">
            <span>Contacto</span>
          </b-nav-item>

        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  name: 'HeaderSoftware',
  data() {
    return {
      limitPosition: 200,
      scrolled: false,
      lastPosition: 0,
    };
  },

  methods: {
    scroll(target) {
      const el = document.querySelector(target);
      if (!el) return;

      const OFFSET = 80;

      const top = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;

      window.scrollTo({
        top,
        behavior: 'smooth',
      });
    },

    handleScroll() {
      const current = window.scrollY;
      this.scrolled = current > 50;
      this.lastPosition = current;
    },
  },

  created() {
    window.addEventListener('scroll', this.handleScroll);
  },

  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style lang="sass">
$image-pattern: url("../assets/img/patterns/img-pattern-header.png")

.header-background
  background-image: $image-pattern

.nav-link-item > span
  font-weight: 600
  letter-spacing: .04em
  text-transform: uppercase
</style>
